module.exports = __webpack_public_path__ + "img/ph.1ae1279e.svg";